module.exports = __webpack_public_path__ + "img/status-support.c33b0238.png";